var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M10.7933 1.33337H5.20659C2.77992 1.33337 1.33325 2.78004 1.33325 5.20671V10.7867C1.33325 13.22 2.77992 14.6667 5.20659 14.6667H10.7866C13.2133 14.6667 14.6599 13.22 14.6599 10.7934V5.20671C14.6666 2.78004 13.2199 1.33337 10.7933 1.33337Z",
    fill: "#636175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 7.5H8.5V4C8.5 3.72667 8.27333 3.5 8 3.5C7.72667 3.5 7.5 3.72667 7.5 4V7.5H4C3.72667 7.5 3.5 7.72667 3.5 8C3.5 8.27333 3.72667 8.5 4 8.5H7.5V12C7.5 12.2733 7.72667 12.5 8 12.5C8.27333 12.5 8.5 12.2733 8.5 12V8.5H12C12.2733 8.5 12.5 8.27333 12.5 8C12.5 7.72667 12.2733 7.5 12 7.5Z",
    fill: "#636175"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.18fff14547ac788bc491f8f2793ca033.svg";
export { ForwardRef as ReactComponent };